import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';

import Select from '@sorare/core/src/atoms/inputs/Select';

type Option = {
  label: ReactNode;
  value: string;
};

type Props = {
  selected: string;
  options: Option[];
  onChange: (scarcity: any) => void;
};

export const RewardPoolFilter = ({ selected, options, onChange }: Props) => {
  const selectedFilter =
    options.find(({ value }) => value === selected) || options[0];
  return (
    <Select
      onChange={newOption => {
        if (newOption) {
          onChange(newOption.value);
        }
      }}
      value={selectedFilter}
      options={options}
      icon={faAngleDown}
    />
  );
};
